import clsx from 'clsx';
import { PropsWithChildren } from 'react';

type CardProps = PropsWithChildren<{
  className?: string;
}>;

export function Card({ className, children }: CardProps) {
  return (
    <div
      className={clsx(
        'flex flex-col',
        'rounded-md border-1 border-outline-l1',
        'pl-20 pr-20 max-tablet-portrait:pl-16 max-tablet-portrait:pr-16 pt-24 pb-24',
        'bg-surface-l0',
        className,
      )}
    >
      {children}
    </div>
  );
}
